(function () {
  'use strict';

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function setUnit(el, unit, value) {
    var node = el.querySelector('[data-pd-countdown-unit="' + unit + '"]');
    if (node) {
      node.textContent = value;
    }
  }

  // 返回 false 表示已到点（调用方停止计时）
  function tick(el, deadline) {
    var diff = deadline - Date.now();
    if (diff <= 0) {
      el.classList.add('is-expired');
      return false;
    }
    var totalSeconds = Math.floor(diff / 1000);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    setUnit(el, 'days', pad(days)); // 天数 >= 100 时 pad 原样返回，不截断
    setUnit(el, 'hours', pad(hours));
    setUnit(el, 'minutes', pad(minutes));
    setUnit(el, 'seconds', pad(seconds));
    return true;
  }

  function init(el) {
    var raw = el.getAttribute('data-deadline');
    var deadline = raw ? Date.parse(raw) : NaN;
    if (!raw || isNaN(deadline)) {
      el.classList.add('is-expired'); // fail-safe：无/非法 deadline 直接隐藏
      return;
    }
    if (!tick(el, deadline)) {
      return; // 初次渲染即已过期
    }
    var timer = setInterval(function () {
      if (!tick(el, deadline)) {
        clearInterval(timer);
      }
    }, 1000);
  }

  function boot() {
    var els = document.querySelectorAll('[data-pd-countdown]');
    for (var i = 0; i < els.length; i++) {
      init(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
